import {useEffect, useId, useState} from 'react';
import Alert from 'react-bootstrap/Alert';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import {getConversation} from '../../service/ChatService';
import {conversationDisplayName, userDisplayName} from './chatUtils';
import ChatAvatar from './ChatAvatar';

const roles = {ADMIN: 'Admin', AGENT: 'Agent', PROPERTY_MANAGER: 'Property manager', WORKER: 'Worker', SUPERVISOR: 'Supervisor'};

function MembersList({conversationId, currentUserId}) {
    const [members, setMembers] = useState(null);
    const [error, setError] = useState(false);
    const [attempt, setAttempt] = useState(0);
    useEffect(() => {
        const controller = new AbortController();
        getConversation(conversationId, controller.signal).then(conversation => {
            if (!controller.signal.aborted) setMembers(conversation.members || []);
        }).catch(() => { if (!controller.signal.aborted) setError(true); });
        return () => controller.abort();
    }, [conversationId, attempt]);

    if (error) return <Alert variant="danger">Unable to load members. <Button variant="link" onClick={() => {setError(false); setAttempt(value => value + 1);}}>Retry</Button></Alert>;
    if (!members) return <p role="status">Loading members…</p>;
    if (!members.length) return <p>No members to display.</p>;
    return <ul className="chat-member-list" aria-label="Conversation members">{members.map(({user}) => <li key={user.id}>
        <ChatAvatar user={user} className="chat-member-avatar"/>
        <div><span className="chat-member-name">{userDisplayName(user)}{user.id === currentUserId ? ' (you)' : ''}</span><span className="chat-member-role">{roles[user.role] || user.role}</span></div>
    </li>)}</ul>;
}

export default function ConversationMembers({conversation, currentUserId}) {
    const [open, setOpen] = useState(false);
    const titleId = useId();
    const count = conversation.member_count ?? conversation.members?.length ?? 0;
    const close = () => setOpen(false);
    return <>
        <button type="button" className="chat-members-button" aria-label={`View ${count} ${count === 1 ? 'member' : 'members'}`} aria-haspopup="dialog" aria-expanded={open} onClick={() => setOpen(true)}>{count} {count === 1 ? 'member' : 'members'}</button>
        <Modal show={open} onHide={close} centered scrollable aria-labelledby={titleId}>
            <Modal.Header closeButton><Modal.Title id={titleId}>Members</Modal.Title></Modal.Header>
            <Modal.Body>
                <p className="chat-members-conversation">{conversationDisplayName(conversation, currentUserId)}</p>
                {open ? <MembersList conversationId={conversation.id} currentUserId={currentUserId}/> : null}
            </Modal.Body>
            <Modal.Footer><Button variant="secondary" onClick={close}>Close</Button></Modal.Footer>
        </Modal>
    </>;
}
